import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hidden", "trigger"]

  show() {
    this.hiddenTargets.forEach(el => el.classList.remove("hidden"))
    this.triggerTarget.classList.add("hidden")
  }
}
